import { render, staticRenderFns } from "./header-ggzy.vue?vue&type=template&id=6fa6e964&scoped=true&"
import script from "./header-ggzy.vue?vue&type=script&lang=js&"
export * from "./header-ggzy.vue?vue&type=script&lang=js&"
import style0 from "./header-ggzy.vue?vue&type=style&index=0&id=6fa6e964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6e964",
  null
  
)

export default component.exports